/**
 * Mailchimp AJAX
 * @description Module for MC ajax sign up submission
 */

/**
 * Module Dependencies
 */
var $ = require( 'jquery' ),
	Util = require( './util' ),
	Cookie = require( 'js-cookie' );

/**
 * Module Vars
 */
var debugEnabled = false,
	debug = debugEnabled ? Util.debug : function () {},
	$form = $( '.footer-mc-form' ),
	$modal = $( '.section-modal-form' )

/**
 * Initializes Module
 */
function init() {
	debug( 'ModuleName' );
	submitModalForm();
	submitFooterForm();
}

function submitModalForm() {

	$('.section-modal-form').submit(function(e) {
		var $this = $(this);
		var $modalMessage = $(this).parent().prev();
		$.ajax({
		      type: "GET", // GET & url for json slightly different
		      url: "//soorploomclothier.us4.list-manage.com/subscribe/post-json?u=858f9f14f4868724dedf3d601&amp;id=8145e84bdc&c=?",
		      data: $this.serialize(),
		      dataType    : 'json',
		      contentType: "application/json; charset=utf-8",
		      error       : function(err) { alert("Could not connect to the registration server."); },
		      success     : function(data) {
		          if (data.result != "success") {
		              $modalMessage.html(data.msg);
		          } else {
					  $modalMessage.text('Check your email for confirmation!');
					  setTimeout( closeSectionModal, 2000);
		          }
		      }
		  });
		  return false;
	});
}

function submitFooterForm() {

	$('.footer-form').submit(function(e) {
		var $this = $(this);
		var $modalMessage = $('.modal-message');
		$.ajax({
		      type: "GET", // GET & url for json slightly different
		      url: "//soorploomclothier.us4.list-manage.com/subscribe/post-json?u=858f9f14f4868724dedf3d601&amp;id=8145e84bdc&c=?",
		      data: $this.serialize(),
		      dataType    : 'json',
		      contentType: "application/json; charset=utf-8",
		      error       : function(err) { alert("Could not connect to the registration server."); },
		      success     : function(data) {
		          if (data.result != "success") {
						Cookie.set('visited', true, { expires: 365 });
						$('.section-modal').addClass('show')
						$('.section-modal-background').addClass('show')
						$('p.modal-message').html(data.msg);
		          } else {
						$modalMessage.html('Check your email for confirmation!');
						$modalMessage.addClass('show');
						setTimeout( function(){
							$modalMessage.removeClass('show');
						}, 2000);
		          }
		      }
		  });
		  return false;
	});
}

function closeSectionModal() {

        $('.newsletter-modal-background, .newsletter-modal').addClass('fade').one('transitionend', function() {
            Cookie.set('visited', true, { expires: 3 });
            $('.newsletter-modal').removeClass('fade')
            $('.newsletter-modal').removeClass('show')
            $('.newsletter-modal-background').removeClass('fade show').one('transitionend', function() {
                $(this).addClass('hide');
            })
        })

}

/**
 * Module Exports
 */
module.exports = {
	init: init
};